// extracted by css-extract-rspack-plugin
export default {"content":"content-Z8sMCb","arrow":"arrow-TJSAF6"};